import React, {Component, ReactElement} from 'react'
import {getQueryParameter, getQueryParameters} from '../../common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import {
    NatResidentLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {NatPostResidentLogin} from '../login/repository/NatPostResidentLogin'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatResidentAdSSOLoginRedirectPage extends Component<Props & ResidentPagePropsSet> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
    }

    async componentDidMount(): Promise<void> {
        SessionStorageHelper.removeAllItem()

        const result: NatPostResidentLogin = this.convertQueryParameterIntoResidentLoginUserInfo()
        const urlAfterLogin = getQueryParameter('urlAfterLogin', window.location.search)
        const errorMessage = getQueryParameter('errorMessage', window.location.search)

        if (errorMessage) {
            this.props.navigate(
                '/resident/error',
                {state: {message: errorMessage}},
            )
            return
        }
        NatResidentLoginInfoSessionStorageHelper.setSessionStorage(result)
        NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(null)
        if (result.role) {
            if (urlAfterLogin) {
                this.props.navigate(urlAfterLogin)
            } else {
                this.props.navigate('/resident/mypage')
            }
        } else {
            if (urlAfterLogin) {
                this.props.navigate('/resident/condominiumSelect', {state: {seniurl: urlAfterLogin}})
            } else {
                this.props.navigate('/resident/condominiumSelect')
            }
        }
        return
    }

    convertQueryParameterIntoResidentLoginUserInfo(): NatPostResidentLogin {
        const authority = getQueryParameters('authority', window.location)

        return {
            userId: getQueryParameter('userId', window.location.search),
            role: getQueryParameter('role', window.location.search),
            authority: authority,
            loginMode: getQueryParameter('loginMode', window.location.search),
            residentUserType: getQueryParameter('residentUserType', window.location.search),
            roleName: getQueryParameter('roleName', window.location.search),
            familyName: getQueryParameter('familyName', window.location.search),
            firstName: getQueryParameter('firstName', window.location.search),
            condominiumCd: getQueryParameter('condominiumCd', window.location.search),
            condominiumName: getQueryParameter('condominiumName', window.location.search),
            ridgeCd: getQueryParameter('ridgeCd', window.location.search),
            ridgeName: getQueryParameter('ridgeName', window.location.search),
            roomNumber: getQueryParameter('roomNumber', window.location.search),
            zipcode: getQueryParameter('zipcode', window.location.search),
            prefectureCd: getQueryParameter('prefectureCd', window.location.search),
            address2: getQueryParameter('address2', window.location.search),
            address3: getQueryParameter('address3', window.location.search),
            imagePath: getQueryParameter('imagePath', window.location.search),
            ssoLoginUrl: null,
            facilityReserveAvailability: getQueryParameter('facilityReserveAvailability', window.location.search),
            boardUserDisplay: getQueryParameter('boardUserDisplay', window.location.search),
            assocDirectorFlag: getQueryParameter('assocDirectorFlag', window.location.search),
            boardResidentAuthority: getQueryParameter('boardResidentAuthority', window.location.search),
            boardAdminAuthority: getQueryParameter('boardAdminAuthority', window.location.search),
            errorInfo: null,
            informations: null,
            requestError: null,
            requestItemErrors: null,
        }
    }

    render(): Nullable<ReactElement> {
        return (
            <>
            </>
        )
    }
}

export default createResidentPage(NatResidentAdSSOLoginRedirectPage)
